/** @format */

import React from 'react';

export default function StatusChip({ status }) {
  return <span className={`chip-status chip-status--${status.replace(' ', '_')}`}>{status}</span>;
}
